export const blogPostSpanishMetadata: Record<
  string,
  {
    title?: string;
    summary?: string;
    readTime?: string;
    category?: string;
    tags?: string[];
  }
> = {
  "how-to-increase-claude-code-generation-quality-by-20-percent": {
    title: "Claude Code: 20 % más calidad de código",
    summary:
      "Los agentes de programación con IA caen al 20-30 % de precisión en bases de código comerciales. Nuestro conjunto de herramientas de código abierto basado en agentes corrige ese problema con búsqueda web estructurada, revisión de código con dos modelos y TDD aplicado con rigor.",
    readTime: "8 min de lectura",
    category: "Tecnología",
    tags: ["Programación con IA", "Claude Code", "MCP", "Código abierto", "TDD"],
  },
  "shelpuk-ai-technology-consulting-recognized-as-a-top-ai-consulting-company": {
    title: "Entre las principales consultoras de IA",
    summary:
      "Vendorland ha reconocido a Shelpuk AI Technology Consulting como una de las principales empresas de consultoría en IA por su experiencia en consultoría de IA, machine learning y analítica de datos.",
    category: "Negocio",
    tags: ["Noticias de la empresa", "Reconocimientos", "Vendorland"],
  },
  "double-your-llama-3-3-inference-speed-with-huggingface-text-generation-inference": {
    title: "Llama 3.3 más rápido con Hugging Face TGI",
    summary:
      "Despliegue Llama 3.3 con Hugging Face TGI para reducir a la mitad el tiempo de inferencia frente a Transformers estándar, con una guía paso a paso y benchmarks en GPUs NVIDIA H100.",
    category: "Tecnología",
    tags: ["LLM", "Llama 3.3", "TGI", "Inferencia", "Despliegue"],
  },
  "buy-vs-build-in-ai-making-the-optimal-technology-choice": {
    title: "Buy vs. Build: la decisión tecnológica en IA",
    summary:
      "¿Conviene comprar servicios de IA o desarrollar una solución propia? Un marco para decidir entre comprar y desarrollar según si busca optimizar costes o construir una ventaja competitiva.",
    category: "Gestión tecnológica",
    tags: ["Estrategia de IA", "Buy vs Build", "Ventaja competitiva"],
  },
  "meet-llama-3-2-edge-llm-vision-agentic-capabilities-and-more": {
    title: "Llama 3.2: LLM en el edge, visión y agentes",
    summary:
      "Llama 3.2 aporta capacidades multimodales, IA en el dispositivo y aplicaciones basadas en agentes. Analizamos qué hace que el último modelo de acceso abierto de Meta resulte especialmente interesante para casos de negocio.",
    category: "Tecnología",
    tags: ["LLM", "Llama 3.2", "Visión", "IA basada en agentes", "IA en edge computing"],
  },
  "so-you-want-to-explore-ai-for-your-company-where-to-start": {
    title: "¿Explorar la IA en su empresa? Por dónde empezar",
    summary:
      "Un marco práctico para directivos que están explorando la IA: consultoría, diseño de solución o implementación, según si el problema y la solución ya están claros.",
    category: "Negocio",
    tags: ["Estrategia de IA", "Consultoría", "Estrategia empresarial"],
  },
  "fine-tuning-llama-3-1-with-swift-unsloth-alternative-for-multi-gpu-llm-training": {
    title: "Fine-tuning de Llama 3.1 con SWIFT: multi-GPU",
    summary:
      "Guía paso a paso para ajustar Llama 3.1 con SWIFT sobre infraestructura multi-GPU de RunPod, incluyendo configuración LoRA, preprocesamiento del conjunto de datos y entrenamiento centrado en la respuesta.",
    category: "Tecnología",
    tags: ["LLM", "SWIFT", "Fine-tuning", "Multi-GPU", "Llama 3.1"],
  },
  "how-to-fine-tune-llama-3-1-with-unsloth-twice-as-fast-and-using-70-less-gpu-memory": {
    title: "Llama 3.1 con Unsloth: el doble de rápido",
    summary:
      "Guía práctica para instalar y usar Unsloth en el ajuste eficiente de LLM sobre plataformas en la nube con GPU, con buenas prácticas para la estructura de instrucciones de Llama 3.1 y entrenamiento centrado en la respuesta.",
    category: "Tecnología",
    tags: ["LLM", "Unsloth", "Fine-tuning", "Llama 3.1"],
  },
  "low-rank-adaptation-lora-for-efficient-fine-tuning-of-large-language-models": {
    title: "Low-Rank Adaptation (LoRA) para LLM eficientes",
    summary:
      "Desmitificamos LoRA: una técnica avanzada para ajustar de forma eficiente grandes modelos de lenguaje como Llama-2, Llama-3 y Mistral mediante descomposición matricial de bajo rango.",
    category: "Tecnología",
    tags: ["LLM", "LoRA", "Fine-tuning", "Aprendizaje automático"],
  },
  "llm-practitioner-s-guide-gemma-a-game-changing-multilingual-llm": {
    title: "Guía para profesionales de LLM: Gemma",
    summary:
      "Gemma marca la llegada del primer chat LLM realmente multilingüe. Analizamos por qué este lanzamiento de Google es un punto de inflexión para las aplicaciones de IA multilingüe.",
    category: "Tecnología",
    tags: ["LLM", "Gemma", "Multilingüe", "Tokenización"],
  },
  "llm-practitioner-s-guide-how-multilingual-falcon-mistral-smaug-and-other-llms-are": {
    title: "Guía para profesionales de LLM: multilingüismo",
    summary:
      "¿Qué tan bien funcionan realmente los LLM supuestamente multilingües? Comparamos Falcon, Mistral, Smaug y otros modelos en distintos idiomas y analizamos qué explican sus diferencias.",
    category: "Tecnología",
    tags: ["LLM", "Multilingüe", "Evaluación", "Tokenización"],
  },
  "llm-practitioner-s-guide-how-multilingual-llama-2-actually-is": {
    title: "Guía para profesionales de LLM: Llama-2",
    summary:
      "Evaluamos las capacidades multilingües reales de Llama-2 y explicamos qué implican sus limitaciones para productos que necesitan rendimiento sólido más allá del inglés.",
    category: "Tecnología",
    tags: ["LLM", "Llama-2", "Multilingüe", "Evaluación"],
  },
  "shelpuk-ai-technology-consulting-honored-as-a-clutch-champion-and-clutch-global-for-2023": {
    title: "Distinguida Clutch Champion y Clutch Global 2023",
    summary:
      "Nos enorgullece haber sido reconocidos como Clutch Champion y Clutch Global 2023, situándonos entre el 10 % de empresas mejor valoradas en Clutch.",
    category: "Negocio",
    tags: ["Noticias de la empresa", "Reconocimientos", "Clutch"],
  },
  "the-tango-takes-two-building-synergy-between-ai-and-product-management": {
    title: "Sinergia entre la IA y la gestión de producto",
    summary:
      "Por qué los productos de IA exitosos requieren una colaboración fluida entre los equipos de IA y de producto, y una checklist práctica para mantener en marcha su círculo virtuoso de IA.",
    category: "Gestión tecnológica",
    tags: ["Estrategia de IA", "Gestión de producto", "Ventaja competitiva"],
  },
  "competent-management-a-surprising-source-of-competitive-advantage": {
    title: "Dirección competente: una ventaja competitiva",
    summary:
      "Por qué una dirección competente es una ventaja competitiva infravalorada y cómo los círculos viciosos de malas prácticas atrapan a las empresas en la mediocridad.",
    category: "Gestión tecnológica",
    tags: ["Dirección", "Ventaja competitiva", "Estrategia"],
  },
  "can-chatgpt-build-a-competitive-advantage-for-your-company-and-if-so-how": {
    title: "¿Puede ChatGPT crear una ventaja competitiva?",
    summary:
      "¿Aporta ChatGPT ventajas competitivas reales para su empresa? Un marco para pensar si los LLM pueden construir una ventaja sostenible más allá del entusiasmo actual por la IA.",
    category: "Negocio",
    tags: ["Estrategia de IA", "ChatGPT", "Ventaja competitiva", "LLM"],
  },
  "all-you-need-is-a-network-effect-how-great-tech-and-ai-products-compete": {
    title: "Efecto red: cómo compiten los productos de IA",
    summary:
      "¿Qué diferencia a las empresas tecnológicas más valiosas? Por qué plataformas, redes sociales, marketplaces y productos de IA convergen en un mismo fenómeno: el efecto de red.",
    category: "Negocio",
    tags: ["Estrategia de IA", "Efectos de red", "Ventaja competitiva"],
  },
  "planning-for-a-new-ai-initiative-start-with-the-right-ai-development-culture": {
    title: "¿Nueva iniciativa de IA? Empiece por la cultura IA",
    summary:
      "Algunos hechos sobre los sistemas de IA son contraintuitivos frente a la ingeniería tradicional. Cuatro principios que distinguen una ventaja competitiva basada en IA del desarrollo de producto convencional.",
    category: "Gestión tecnológica",
    tags: ["Estrategia de IA", "Cultura de ingeniería", "Ventaja competitiva"],
  },
  "lacking-data-for-machine-learning-models-build-for-the-future-data": {
    title: "¿Faltan datos para ML? Diseñe para el futuro",
    summary:
      "Por qué los datos disponibles hoy no son un requisito previo para construir un negocio basado en IA y cómo diseñar para los datos futuros crea una ventaja competitiva defendible.",
    category: "Negocio",
    tags: ["Estrategia de IA", "Aprendizaje automático", "Estrategia de datos"],
  },
  "why-do-you-need-an-ai-strategy-ai-as-a-competitive-advantage": {
    title: "¿Por qué necesita una estrategia de IA?",
    summary:
      "Cómo la IA crea ventajas competitivas sostenibles a través de efectos de red y ciclos virtuosos de datos, ilustrado con la historia de Blue River Technology.",
    category: "Negocio",
    tags: ["Estrategia de IA", "Ventaja competitiva", "Efectos de red"],
  },
  "what-is-your-ai-business-use-case-how-ai-can-help-and-harm-your-strategic-positioning": {
    title: "¿Cuál es su caso de uso de negocio para IA?",
    summary:
      "Por qué la mayoría de los consejos sobre casos de uso de IA desvían a las empresas y cómo distinguir herramientas operativas de una ventaja competitiva real.",
    category: "Negocio",
    tags: ["Estrategia de IA", "Estrategia empresarial", "Ventaja competitiva"],
  },
  "building-a-sustainable-ai-competitive-advantage-four-ai-designs-that-don-t-work": {
    title: "Cuatro diseños de IA que no dan ventaja",
    summary:
      "No todas las estrategias de IA crean una ventaja competitiva duradera. Cuatro diseños de IA habituales que llevan a las empresas por mal camino y qué hacer en su lugar.",
    category: "Negocio",
    tags: ["Estrategia de IA", "Ventaja competitiva", "Aprendizaje automático"],
  },
  "ai-strategies-that-offer-a-sustainable-competitive-advantage-principles-you-should-follow": {
    title: "Estrategias de IA para una ventaja sostenible",
    summary:
      "Seis principios para asegurarse de que su inversión en IA construya una ventaja competitiva defendible y no acabe atrapada en una carrera de comoditización.",
    category: "Negocio",
    tags: ["Estrategia de IA", "Ventaja competitiva", "Efectos de red"],
  },
};
